import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextBoxComponent } from './textbox.component';
import { TextBoxModule } from './textbox.module';
/**
 * NgModule definition for the TextBox component with providers.
 */
export class TextBoxAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, TextBoxModule],
    exports: [
        TextBoxModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TextBoxAllModule_tsickle_Closure_declarations() {
/** @type {?} */
TextBoxAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TextBoxAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
